import React, { memo } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import dayjs from 'dayjs'

import TestIds from '../../../../testIds'
import { ItemContainer, ItemValue } from '../../../../components/styled'
import { SideContainer } from '../../../products/components/ProductCard/ProductCard'

const CreatedAt = ({ createdAt }: { createdAt: Date | string }) => {
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  const renderedItem = (
    <ItemContainer wrap={isSmall}>
      <ItemValue
        variant={isSmall ? 'body2' : 'caption'}
        align={isSmall ? 'left' : 'right'}
        data-testid={TestIds.feat.quotes.card.expiryDate}
      >
        Created {dayjs(createdAt).format('DD MMM YYYY')}
      </ItemValue>
    </ItemContainer>
  )

  if (isSmall) return renderedItem

  return <SideContainer sx={{ m: 0, ml: 'auto' }}>{renderedItem}</SideContainer>
}

export const QuoteCreatedAt = memo(CreatedAt)
